import { useQuery } from '@vue/apollo-composable'
import getPromotedBonusGql from 'src/apollo/queries/getPromotedBonus.gql'
import { useStore } from 'vuex'

export const CONDITION_DEPOSIT = 3

export function useGetPromotedBonus() {
  function getPromotedBonus(storeOptions) {
    const store = useStore() || storeOptions

    const { onResult } = useQuery(getPromotedBonusGql, {}, { fetchPolicy: 'network-only' })

    onResult(({ data }) => {
      const promotedBonusList = data.propsContentList?.map((i) => {
        return {
          program: i.programs?.[0],
          props: JSON.parse(i.props),
        }
      })

      store.commit('UPDATE_PROMOTED_BONUS_LIST', promotedBonusList)
    })
  }

  return { getPromotedBonus }
}
